import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CrossCircleStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M14.9705 7.96973C15.2634 7.67683 15.7381 7.67685 16.031 7.96973C16.3239 8.26261 16.3239 8.73737 16.031 9.03027L13.0603 12L16.0301 14.9697L16.0818 15.0264C16.3222 15.321 16.3047 15.7556 16.0301 16.0303C15.7554 16.3048 15.3207 16.3224 15.0262 16.082L14.9695 16.0303L12.0008 13.0605L9.03201 16.0303C8.73916 16.3232 8.26438 16.3231 7.97146 16.0303C7.67856 15.7374 7.67859 15.2626 7.97146 14.9697L10.9402 12L7.97049 9.03027L7.91873 8.97363C7.67842 8.67905 7.69589 8.24433 7.97049 7.96973C8.2451 7.69515 8.67983 7.67767 8.97439 7.91797L9.03103 7.96973L12.0008 10.9395L14.9705 7.96973Z"
				fill="currentColor"
			/>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CrossCircleStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CrossCircleStrokeIcon;
